import { render } from "./shopMemos.vue?vue&type=template&id=2134d6a4&scoped=true"
import script from "./shopMemos.vue?vue&type=script&lang=js"
export * from "./shopMemos.vue?vue&type=script&lang=js"

import "./shopMemos.vue?vue&type=style&index=0&id=2134d6a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2134d6a4"]])

export default __exports__